import { gql } from '@apollo/client';
import { CHANNEL } from '../../../components/myeirconstant/myEirConstant';

const ADDON_SCHEMA = `
  offerType
  serviceGroup
  code
  description
  channel
  charges{
      price
    }
  displayName
  details
  attributes {
    type
    value
    sortOrder
    icon
}
`;
const ENDPOINT = {
    GET_ELIGIBILITY_FOR_MANAGE_ADDONS: gql`
        query getAccountStatusAndCollectionStatus($accountId: String!) {
            getAccountStatus(accountId: $accountId) {
                status
                brand
            }
            getAccountCollectionStatus(accountId: $accountId)
        }
    `,
    GET_ACTIVE_ADDONS: gql`
        query getCurrentlySubscribedAddons($serviceId: Int!) {
            getCurrentlySubscribedAddons(serviceId: $serviceId) {
                id
                code
                description
                itemGroupCode
                status
                charges {
                    priceVatIncluded
                    billingType
                }
                activatedAt
                terminatedAt
            }
        }
    `,

    GET_ADDONS: gql`
    query getAddOns(
      $offerTypeCode: String
      $serviceGroupCode: String
      $channel:String
      $codes: [String]
    ) {
      getAddOns(
          offerTypeCode: $offerTypeCode
          serviceGroupCode: $serviceGroupCode
          channel: $channel
          codes: $codes
      ) {
        ${ADDON_SCHEMA}
      }
    }
  `,
    ADD_ADDON_TO_SERVICE: gql`
        mutation addAddonToService($addonRequest: AddAddonInput!) {
            addAddonToService(addonRequest: $addonRequest)
        }
    `,
    REMOVE_ADDONS: gql`
        mutation deleteAddons($addOnId: Int!, $serviceId: Int) {
            deleteAddons(addOnId: $addOnId, serviceId: $serviceId)
        }
    `,
};

/**
 * @name getEligibilityForManageAddons - gets eligiblity checks for managing addons
 * @param {Object} Obj - attributes for the function
 * @param {GraphQL} Obj.graphql - appoloclient graphql constant
 * @param {GraphQL} graphql - appoloclient graphql constant
 * @returns {AccountAndCollectionStatus} - account's & collection status
 */
export const getEligibilityForManageAddons = async ({
    graphql,
    setCollectionStatus,
    setAccountStatus,
}) => {
    try {
        const { data } = await graphql.query({
            query: ENDPOINT.GET_ELIGIBILITY_FOR_MANAGE_ADDONS,
            variables: {
                accountId: sessionStorage.getItem('LoggedinUserAccountNumber'),
            },
        });
        setCollectionStatus(data.getAccountCollectionStatus);
        setAccountStatus(data.getAccountStatus.status);
        return data;
    } catch (error) {
        throw new Error(error);
    }
};
/**
 * @name getAddOnsApi - to get Addons
 * @param {Object} Obj - attributes for the function
 * @param {GraphQL} Obj.graphql - appoloclient graphql constant
 * @param {GraphQL} graphql - appoloclient graphql constant
 * @returns
 */
export const getAddOnsApi = async ({ graphql, serviceGroupCode, codes }) => {
    const { data } = await graphql.query({
        query: ENDPOINT.GET_ADDONS,
        variables: {
            // offerTypeCode: 'POSTPAY',
            // serviceGroupCode,
            channel: CHANNEL,
            codes,
        },
    });
    return data.getAddOns;
};

/**
 * @name getActiveAddons - gets active addons for managing addons
 * @param {Object} Obj - attributes for the function
 * @param {GraphQL} Obj.graphql - appoloclient graphql constant
 * @param {GraphQL} graphql - appoloclient graphql constant
 * @returns {ActiveAddons} - active addons
 */
export const getActiveAddons = async ({ graphql, servicesIds }) => {
    try {
        const { data } = await graphql.query({
            query: ENDPOINT.GET_ACTIVE_ADDONS,
            variables: {
                serviceId: servicesIds,
            },
        });

        return data;
    } catch (error) {
        throw new Error(error);
    }
};

export const addAddonToServiceApi = async ({ graphql, addonRequest }) => {
    try {
        const { data } = await graphql.mutate({
            mutation: ENDPOINT.ADD_ADDON_TO_SERVICE,
            variables: {
                addonRequest,
            },
        });
        return data;
    } catch (error) {
        throw new Error(error);
    }
};

export const removeAddonApi = async ({ graphql, addOnId, serviceId }) => {
    try {
        const { data } = await graphql.mutate({
            mutation: ENDPOINT.REMOVE_ADDONS,
            variables: {
                addOnId,
                serviceId,
            },
        });

        return data;
    } catch (error) {
        throw new Error(error);
    }
};
